module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAABY0lEQVQ4jZXTv0tXURgG8M/3+lUTCZfI0SEhB0GaKnAKLKEvLkL/gbikLSK4NiQUTYW//gaHhnAJvCBBOYhG2uAgBoFIVpCDkBEO9146HI7i94HLved5n+fhvJf3reV5LkI/xjGEnpLbxzssYTsUZ8F3O17jEx7jJq6UTx8msIVXaKtM9fLdhhXci68ToSUIb+BPdYPZS5hDDOFZ1UIvnjRhrjCJG5nih7UkBAu4jTtYTNRbMVbHg0TxBaaD8zqOMRXphqsWYjw/JzRGb4aOiPyLHwnx9wTXmZWGEHVF3zEGE9xphs+JwjyuB+duzCV0O3Us41ZUGMAu3qKGh+hKBLyp5Xl+DXu4mhBchBPlHBxhpkkzPMVBNcrzWGvCvIGX/N/Gf3iEb5cwH2EUp2EAHGIEvy8wn5SarxWRRYJNxWgfn2Nu4ENIxgHwUbGuPwPuF+5jNRanAiiW5y6+YEcxme9TwjOgxEHauSp8SQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dingwei.png
// module id = LhNr
// module chunks = 0